/* eslint-disable max-classes-per-file */
interface Baggage {
  isSelected: boolean;
  baggageList: any[];
}

interface FlightInsurance {
  isSelected: boolean;
  status: boolean;
  message: string;
  wholesaleName: string;
  planName: string;
  price: number;
}

interface FlightSeat {
  isSelected: boolean;
  seatList: any[];
}

interface PassengerInfo {
  passengerNumber: number;
  baggage: Baggage;
  baggageTracking: any;
  flightInsurance: FlightInsurance;
  flightSeat: FlightSeat;
}

export interface FlightAllocateResponse {
  bookingInternalNo: string;
  rsvnId: string;
  sellingPrice: number;
  baggagePrice: number;
  insurancePrice: number;
  baggageTrackingPrice: number;
  seatPrice: number;
  mealPrice: number;
  priceIncrease: number;
  currency: string;
  passengerInfo: PassengerInfo[];
  paymentUrl: string;
  status: boolean;
  message: string;
}

export class FlightPriceChange {
  isAllocatePriceChange: boolean;

  priceChange: number;

  newPrice: number;

  oldPrice: number;

  departure: {
    oldPriceChange: number;
    newPriceChange: number;
    diff: number;
  } | null;

  return: {
    oldPriceChange: number;
    newPriceChange: number;
    diff: number;
  } | null;

  roundtrip: null;

  changePrice: number;

  constructor(data: any) {
    this.isAllocatePriceChange = data?.isAllocatePriceChange;
    this.priceChange = data?.priceChange;
    this.newPrice = data?.newPrice;
    this.oldPrice = data?.oldPrice;
    this.departure = data?.departure;
    this.return = data?.return;
    this.roundtrip = data?.roundtrip;
    this.changePrice = data?.changePrice;
  }
}

export class FlightAllocateData {
  bookingInternalNo: string;

  rsvnId: string;

  sellingPrice: number;

  baggagePrice: number;

  insurancePrice: number;

  baggageTrackingPrice: number;

  seatPrice: number;

  mealPrice: number;

  priceIncrease: number;

  currency: string;

  passengerInfo: PassengerInfo[];

  paymentUrl: string;

  priceChange: FlightPriceChange;

  constructor(res) {
    this.bookingInternalNo = res?.bookingInternalNo || "";
    this.rsvnId = res?.rsvnId || "";
    this.sellingPrice = res?.SellingPrice || 0;
    this.baggagePrice = res?.baggagePrice || 0;
    this.insurancePrice = res?.insurancePrice || 0;
    this.baggageTrackingPrice = res?.baggageTrackingPrice || 0;
    this.seatPrice = res?.seatPrice || 0;
    this.mealPrice = res?.mealPrice || 0;
    this.priceIncrease = res?.priceIncrease || 0;
    this.currency = res?.currency || "";

    this.passengerInfo = res?.passengerInfo || [
      {
        passengerNumber: 0,
        baggage: { isSelected: false, baggageList: [] },
        baggageTracking: [],
        flightInsurance: {
          isSelected: false,
          status: false,
          message: "",
          wholesaleName: "",
          planName: "",
          price: 0,
        },
        flightSeat: { isSelected: false, seatList: [] },
      },
    ];

    this.paymentUrl = res?.paymentUrl || "";

    this.priceChange = new FlightPriceChange(res?.priceChange);
  }
}
export class FlightAllocateResponse {
  status: boolean;

  message: string;

  code: string;

  version: string;

  data: FlightAllocateData;

  constructor(res: any) {
    this.status = res?.status ? res?.status : true;
    this.message = res?.message || "";
    this.code = res?.code || "";
    this.version = res?.version || "";
    this.data = new FlightAllocateData(res.data);
  }
}
